<section class="w-full h-screen bg-dark p-8 text-white">
  <h2 class="text-2xl font-semibold mb-6">Administración</h2>
  <ul class="space-y-2">
    @for(item of items; track item.route) {
    <li
      [ngClass]="{
        'bg-gray-700 text-white border-l-4 border-primary': isActive(
          item.route
        ),
        'hover:bg-gray-700 hover:text-white transition': true
      }"
      (click)="navigate(item.route)"
      class="cursor-pointer px-4 py-3 rounded-md flex items-center space-x-3"
    >
      <ng-icon [name]="item.icon" size="20" class="text-primary"></ng-icon>
      <span class="font-light">{{ item.name }}</span>
    </li>
    }
  </ul>
</section>
